// CSS Unit reference: https://www.w3schools.com/cssref/css_units.asp
// Absolute Lengths
type CentimeterValue = string;
type MillimeterValue = string;
type InchValue = string;
type PixelValue = string;
type PointValue = string;
type PicaValue = string;

// Relative Lengths
type PercentValue = string;
type ElementValue = string;
type RootElementValue = string;
type ViewportWidthValue = string;
type ViewportHeightValue = string;
type ViewportMinValue = string;
type ViewportMaxValue = string;

export type CSSLengthUnit =
  | CentimeterValue
  | ElementValue
  | InchValue
  | MillimeterValue
  | PercentValue
  | PicaValue
  | PixelValue
  | PointValue
  | RootElementValue
  | ViewportHeightValue
  | ViewportMaxValue
  | ViewportMinValue
  | ViewportWidthValue;

export const cssLengthUnits = {
  // Absolute Lengths
  cm: (value: number): CentimeterValue => `${value}cm`,
  // Relative Lengths
  em: (value: number): ElementValue => `${value}em`,
  in: (value: number): InchValue => `${value}in`,
  mm: (value: number): MillimeterValue => `${value}mm`,
  pc: (value: number): PicaValue => `${value}pc`,
  pct: (value: number): PercentValue => `${value}%`,

  pt: (value: number): PointValue => `${value}pt`,
  px: (value: number): PixelValue => `${value}px`,
  rem: (value: number): RootElementValue => `${value}rem`,
  vh: (value: number): ViewportHeightValue => `${value}vh`,
  vmax: (value: number): ViewportMaxValue => `${value}vmax`,
  vmin: (value: number): ViewportMinValue => `${value}vmin`,
  vw: (value: number): ViewportWidthValue => `${value}vw`,
};
